<button mat-button [matMenuTriggerFor]="menu">{{title}}</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="opt.path" *ngFor="let opt of options">{{opt.titulo}}</button>
</mat-menu>